module.exports = "//static.hsappstatic.net/LoginUI/static-1.14441/img/warning.svg"